/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteQueue.defs.js'
export { main as default } from './deleteQueue.defs.js'
